<!--<link rel="stylesheet" href="../flow-chart-container/flow-chart-container.component.scss">-->
<div class="tree-container flex flex-col full-grow-no-shrink-no-basis" data-cy="qnr-designer-container">

    <div class="tree-container-header" data-cy="qnr-designer-header">
        <div class="cell left" data-cy="qnr-designer-header-field">
            <span>Field</span>
            <span *ngIf="section?.metaData['Counter']" style="padding-left: 10px;">({{section.metaData['Counter']}}
                )</span>
        </div>
        <div class="cell right" data-cy="qnr-designer-header-type">
            Type
        </div>
    </div>
    <mat-tree class="custom-tree" data-cy="qnr-designer-tree" [dataSource]="dataSource" [treeControl]="treeControl" cdkDropList
              (cdkDropListDropped)="drop($event)">
        <mat-tree-node class="custom-tree-node" style="position:relative" [id]="node.id"
                       [attr.data-cy]="'qnr-field-node-' + node.item?.title"
                       [ngClass]="{'control-show': node.item.id === selectedNodeId,'frozen-node':node.item.frozen==true,'excluded-item':node.item.isHidden==true || node.item.isParentHidden==true}"
                       attr.question-id="{{node.item.questionId}}"
                       (click)="onSelectedNode(node); $event.stopPropagation();"
                       *matTreeNodeDef="let node" matTreeNodeToggle cdkDrag [cdkDragData]="node"
                       [cdkDragDisabled]="isDragDisabled"
                       (mouseenter)="dragHover(node)" (mouseleave)="dragHoverEnd()" (cdkDragStarted)="dragStart()"
                       (cdkDragReleased)="dragEnd()">
            <div *ngIf="flowChartDataService.excludeHiddenQuestions && menuConfig.addField.isVisible && !isFieldSchema"
                 class="flow-chart-control">
                <a *ngIf="node.item.visibilityLogicGate.visibilityType !== 'AlwaysHidden'" title="Add Field"
                   (click)="onAdd(node,isManageFields)"
                   [attr.data-cy]="'qnr-add-field-control-' + node.item?.title">
                    <i class="fal fa-plus-circle flex flex-row justify-center items-center"></i>
                </a>
                <!--<a *ngIf="!isManageFields" title="Add Question" (click)="onAdd(node,false)">
                  <i class="fal fa-plus-circle" fxLayout="row" fxLayoutAlign="center center"></i>
                </a>-->
                <a [ngClass]="{'disabled': !flowChartControlPanel.isMoveUp}" title="Move to Up" (click)="moveUp(node)"
                   [attr.data-cy]="'qnr-move-up-' + node.item?.title">
                    <i class="fal fa-arrow-to-top flex flex-row justify-center items-center"></i>
                </a>
                <a *ngIf="!isManageFields" [ngClass]="{'disabled': !flowChartControlPanel.isMoveLeft}"
                   title="Move to Left"
                   (click)="moveLeft(node)"
                   [attr.data-cy]="'qnr-move-left-' + node.item?.title">
                    <i class="fal fa-arrow-to-left flex flex-row justify-center items-center"></i>
                </a>
                <a *ngIf="!isManageFields" [ngClass]="{'disabled': !flowChartControlPanel.isMoveRight}"
                   title="Move to Right"
                   (click)="moveRight(node)"
                   [attr.data-cy]="'qnr-move-right-' + node.item?.title">
                    <i class="fal fa-arrow-to-right flex flex-row justify-center items-center"></i>
                </a>
                <a [ngClass]="{'disabled': !flowChartControlPanel.isMoveDown}" title="Move to Bottom"
                   (click)="moveDown(node)"
                   [attr.data-cy]="'qnr-move-down-' + node.item?.title">
                    <i class="fal fa-arrow-to-bottom flex flex-row justify-center items-center"></i>
                </a>
            </div>
            <div class="node-wrapper" [style.padding-left.px]="getMatTreeNodePadding(node)" [ngClass]="{'state-highlight': node.item.id === selectedNodeId,
          'state-hidden':node.item.visibilityLogicGate.visibilityType==='AlwaysHidden'}">
                <div class="left-section flex flex-row justify-start items-center full-grow-no-shrink-no-basis">
                    <div class="button-container">

                    </div>
                    <div *ngIf="hasCheckbox" style="display: flex;">
                        <mat-checkbox
                                [attr.data-cy]="'qnr-field-checkbox-' + node.item?.title"
                                [disabled]="node.item?.fieldValues['DisableSelection'] === true"
                                [checked]="node.item?.isChecked"
                                (change)="onSelectionChange($event, node)">
                        </mat-checkbox>
                    </div>
                    <div class="content-container flex flex-row justify-start items-center full-grow-no-shrink-no-basis">
                        <div *ngIf="node.item?.conditionDisplayText && node.item?.conditionDisplayText.length>0"
                             class="tagg flex flex-row justify-start items-center">
                            <div class="custom-icon flex flex-col">
                                <span></span>
                                <span></span>
                            </div>
                            {{node.item?.conditionDisplayText}}
                        </div>
                        <div class="content flex flex-row justify-start items-start full-grow-no-shrink-no-basis"
                             title=" {{node.item?.instruction ? node.item?.instruction : ''}}">
                            <div>{{node.item?.questionId}}.</div>
                            <div class="m-l-5 content-title">{{node.item?.title}} {{node.item?.isMandatory ? ' *' : ''}}</div>
                            <div class="description flex-1-0-auto hide"
                                 title="{{node.item?.instruction ? node.item?.instruction : ''}}">
                                {{node.item?.instruction ? node.item?.instruction : ''}}</div>
                        </div>
                    </div>
                </div>
                <div *ngIf="isManageFields || isFieldSchema" class="single-node-menu-container m-r-14">
                    <div class="tags-container">
                        <div *ngIf="node.item?.identityField" class="tag">
                            <span>Primary Key</span>
                        </div>
                        <div *ngIf="node.item?.formulaField" class="tag">
                            <span>Formula Field</span>
                        </div>
                      <div *ngIf="node.item?.questionType ==='Question' && !node.item?.parentId" class="tag">
                        <span matTooltip="Question: Data submitted for this item is for reference only.">Field</span>
                      </div>
                      <div *ngIf="node.item?.questionType ==='Question' && node.item?.parentId" class="tag">
                        <span matTooltip="Question: Data submitted for this item is for reference only.">Subfield</span>
                      </div>
                        <div *ngIf="node.item?.questionType==='Field'" class="tag">
            <span
                    matTooltip="Field: Data submitted for this item can be stored in the relevant field inside ITP.">Field</span>
                        </div>
                        <div *ngIf="node.item?.questionType==='Snippet'" class="tag">
            <span
                    matTooltip="Field: Data submitted for this item can be stored in the relevant field inside ITP.">Snippet</span>
                        </div>
                        <div *ngIf="node.item?.fieldValues?.FormulaExpression" class="tag">
            <span
                    matTooltip="This is a formula field, and the value will be calculated from its subfields. Click this button to review and edit the formula.">Formula
              ({{node.item?.fieldValues.FormulaFieldsCount}})</span>
                        </div>
                        <div *ngIf="node.item?.fieldValues?.CountryCodesCount != null" class="tag">
                            <span>Country ({{node.item.fieldValues.CountryCodesCount}})</span>
                        </div>
                        <div *ngIf="node?.level > 0 && this.flowChartDataService?.fieldValues?.IsAutoGeneratedFile"
                             class="tag">
                            <span>Subfield</span>
                        </div>
                    </div>
                    <button *ngIf="menuConfig.menuVisibility.isVisible" mat-icon-button [matMenuTriggerFor]="actionMenu"
                            class="no-animation-btn icon-dropdown-button"
                            [attr.data-cy]="'qnr-field-actions-' + node.item?.title"
                            (click)="triggerForMatMenu(node)">
                        <mat-icon class="s-20">more_horiz</mat-icon>
                    </button>
                    <mat-menu #actionMenu="matMenu" class="action-button-dropdown-container" [overlapTrigger]="false">
                        <button
                                *ngIf=" !flowchart.isCustom &&  node.item.visibilityLogicGate.visibilityType !== 'AlwaysHidden' && !node.item.isHidden &&
                                menuConfig.addField.isVisible && (!isFieldSchema || !node.item?.parentId)"
                                mat-menu-item matTooltipPosition="left" (click)="onAdd(node,true)"
                                [attr.data-cy]="'qnr-add-subfield-' + node.item?.title"
                                [matTooltip]="!isManageFields?'Note: Adding a new Field or Sub-Field to your Data Survey means any responses given for this field will be stored inside ITP in the relevant source data screen.':null"
                                matTooltipPosition="'left'">
                            <span>{{menuConfig.addField.displayText}}</span>
                        </button>
                        <button
                                *ngIf="!node.item.isHidden && !node.item.frozen && !node.item.identityField && menuConfig.editField.isVisible"
                                mat-menu-item (click)="editQuestion(node)"
                                [attr.data-cy]="'qnr-edit-field-' + node.item?.title">
                            <span>{{menuConfig.editField.displayText}}</span> <!--{{node.item?.questionType}}-->
                        </button>
                        <button
                                *ngIf="!node.item.isHidden && flowChartDataService.excludeHiddenQuestions  && (!isManageFields || node.item.isCustom ) && menuConfig.details.isVisible"
                                mat-menu-item (click)="onEditDetailsAndInstructions(node)"
                                [attr.data-cy]="'qnr-details-' + node.item?.title">
                            <span>{{menuConfig.details.displayText}}</span> <!--{{node.item?.questionType}}-->
                        </button>
                        <button
                                *ngIf="!node.item.isHidden && !node.item.frozen && !node.item.identityField && ( node.item.isCustom || menuConfig.deleteField.isVisible)"
                                mat-menu-item class="" (click)="delete(node)"
                                [attr.data-cy]="'qnr-delete-field-' + node.item?.title">
                            <span>{{menuConfig.deleteField.displayText}}</span>
                        </button>
                        <button
                                *ngIf="!node.item.isHidden && !node.item.frozen && !node.item.identityField && menuConfig.manageCountry.isVisible && node.item?.parentId"
                                mat-menu-item class="" (click)="manageCountry(node)"
                                [attr.data-cy]="'qnr-manage-country-' + node.item?.title">
                            <span>{{menuConfig.manageCountry.displayText}}</span>
                        </button>
                        <button *ngIf="!node.item.isHidden && menuConfig.moveField.isVisible" mat-menu-item class=""
                                (click)="moveQuestionBetweenSection(node);$event.stopPropagation();"
                                [attr.data-cy]="'qnr-move-field-' + node.item?.title">
                            <span>{{menuConfig.moveField.displayText}}</span>
                        </button>
                        <button *ngIf="!node.item.isHidden && node.item.hasQualifyingSurvey" mat-menu-item class=""
                                (click)="askXatBot(node);$event.stopPropagation();"
                                [attr.data-cy]="'qnr-ask-xatbot-' + node.item?.title">
                            <span>Ask XatBot</span>
                        </button>
                    </mat-menu>
                </div>
                <div *ngIf="!(isManageFields || isFieldSchema)" class="single-node-menu-container m-r-14">
                    <div class="tags-container">
                        <div *ngIf="node.item?.identityField" class="tag">
                            <span>Primary Key</span>
                        </div>
                        <div *ngIf="node.item?.formulaField" class="tag">
                            <span>Formula Field</span>
                        </div>
                      <div *ngIf="node.item?.questionType ==='Question' && !node.item?.parentId" class="tag">
                        <span matTooltip="Question: Data submitted for this item is for reference only.">Field</span>
                      </div>
                      <div *ngIf="node.item?.questionType ==='Question' && node.item?.parentId" class="tag">
                        <span matTooltip="Question: Data submitted for this item is for reference only.">Subfield</span>
                      </div>
                        <div *ngIf="node.item?.questionType==='Field'" class="tag">
            <span
                    matTooltip="Field: Data submitted for this item can be stored in the relevant field inside ITP.">Field</span>
                        </div>
                        <div *ngIf="node.item?.questionType==='Snippet'" class="tag">
            <span
                    matTooltip="Field: Data submitted for this item can be stored in the relevant field inside ITP.">Snippet</span>
                        </div>
                        <div *ngIf="node.item?.fieldValues?.FormulaExpression" class="tag">
            <span
                    matTooltip="This is a formula field, and the value will be calculated from its subfields. Click this button to review and edit the formula.">Formula
              ({{node.item?.fieldValues.FormulaFieldsCount}})</span>
                        </div>
                        <!--<div *ngIf="node?.level > 0 && this.flowChartDataService?.fieldValues?.IsAutoGeneratedFile"
                             class="tag">
                            <span>Subfield</span>
                        </div>-->
                    </div>
                    <button mat-icon-button [matMenuTriggerFor]="actionMenu"
                            class="no-animation-btn icon-dropdown-button"
                            [attr.data-cy]="'qnr-field-actions-' + node.item?.title"
                            (click)="triggerForMatMenu(node)">
                        <mat-icon class="s-20">more_horiz</mat-icon>
                    </button>
                    <mat-menu #actionMenu="matMenu" class="action-button-dropdown-container" [overlapTrigger]="false">
                        <button
                                *ngIf="flowChartDataService.excludeHiddenQuestions &&  node.item.visibilityLogicGate.visibilityType !== 'AlwaysHidden' &&!node.item.isHidden && !isManageFields && menuConfig.addField.isVisible"
                                mat-menu-item class="" (click)="onAdd(node,false)"
                                [attr.data-cy]="'qnr-add-subfield-' + node.item?.title"
                                [matTooltip]="menuConfig.addField.tooltip"
                                matTooltipPosition="left">
                            <span>{{menuConfig.addField.displayText}}</span>
                        </button>
                        <button *ngIf="!node.item.isHidden && menuConfig.editField.isVisible" mat-menu-item class=""
                                (click)="editQuestion(node)"
                                [attr.data-cy]="'qnr-edit-field-' + node.item?.title">
                            <span>{{menuConfig.editField.displayText}}</span> <!--{{node.item?.questionType}}-->
                        </button>
                        <button
                                *ngIf="!node.item.isHidden && flowChartDataService.excludeHiddenQuestions && (isManageFields===false || node.item.isCustom === true) && menuConfig.details.isVisible"
                                mat-menu-item class="" (click)="onEditDetailsAndInstructions(node)"
                                [attr.data-cy]="'qnr-details-' + node.item?.title">
                            <span>{{menuConfig.details.displayText}}</span> <!--{{node.item?.questionType}}-->
                        </button>
                        <button
                                *ngIf="flowChartDataService.excludeHiddenQuestions && !node.item.isHidden && node.item.questionType!=='Field' && menuConfig.deleteField.isVisible"
                                mat-menu-item class="" (click)="delete(node)"
                                [attr.data-cy]="'qnr-delete-field-' + node.item?.title">
                            <span>{{menuConfig.deleteField.displayText}}</span>
                        </button>
                        <button
                                *ngIf="node.item.questionType==='Field' && !node.item.frozen && !node.item.identityField && menuConfig.includeExcludeField.isVisible"
                                mat-menu-item class="" (click)="excludeQuestion(node)"
                                [attr.data-cy]="'qnr-include-exclude-field-' + node.item?.title">
                            <span>{{node.item.isHidden ? 'Include' : 'Exclude'}}</span>
                        </button>
                        <button *ngIf="!node.item.isHidden && menuConfig.conditions.isVisible" mat-menu-item class=""
                                (click)="addCondition(node,'Conditions');$event.stopPropagation();"
                                [attr.data-cy]="'qnr-conditions-' + node.item?.title">
                            <span>{{menuConfig.conditions.displayText}}</span>
                        </button>
                        <button
                                *ngIf="flowChartDataService.excludeHiddenQuestions && !node.item.isHidden && menuConfig.moveField.isVisible"
                                mat-menu-item class=""
                                (click)="moveQuestionBetweenSection(node);$event.stopPropagation();"
                                [attr.data-cy]="'qnr-move-field-' + node.item?.title">
                            <span>{{node.item.questionType === 'Field' ? menuConfig.moveField.displayText : 'Move Field'}}</span>
                        </button>
                        <button *ngIf="!node.item.isHidden && menuConfig.addSnippet.isVisible" mat-menu-item class=""
                                (click)="addSnippet(node,true,snippetView.LiquidTempate);$event.stopPropagation();"
                                [attr.data-cy]="'qnr-add-snippet-' + node.item?.title">
                            <span>{{menuConfig.addSnippet.displayText}}</span>
                        </button>
                        <button *ngIf="!node.item.isHidden && menuConfig.addMapQuestion.isVisible" mat-menu-item
                                class=""
                                (click)="addMapQuestion(node);$event.stopPropagation();"
                                [attr.data-cy]="'qnr-add-map-question-' + node.item?.title">
                            <span>{{menuConfig.addMapQuestion.displayText}}</span>
                        </button>
                        <button
                                *ngIf="!node.item.isHidden && menuConfig.manageSubFields.isVisible && (node.item.dataType === 'Number')"
                                mat-menu-item class="" (click)="manageSubFields(node)"
                                [attr.data-cy]="'qnr-manage-subfields-' + node.item?.title">
                            <span>{{menuConfig.manageSubFields.displayText}}</span> <!--{{node.item?.questionType}}-->
                        </button>
                        <button
                                *ngIf="!node.item.isHidden && menuConfig.manageFormula.isVisible && IsDataTypeNumberOrPercentage(node)"
                                mat-menu-item class="" (click)="manageFormula(node)"
                                [attr.data-cy]="'qnr-manage-formula-' + node.item?.title">
                            <span>{{menuConfig.manageFormula.displayText}}</span> <!--{{node.item?.questionType}}-->
                        </button>
                      <button
                        *ngIf="!node.item.isHidden && menuConfig.viewFormula.isVisible  && IsDataTypeNumberOrPercentage(node) && !node.item?.parentId"
                        mat-menu-item class="" (click)="viewFormula(node)"
                        [attr.data-cy]="'qnr-view-formula-' + node.item?.title">
                        <span>{{menuConfig.viewFormula.displayText}}</span> <!--{{node.item?.questionType}}-->
                      </button>
                        <button *ngIf="!node.item.isHidden && node.item.hasQualifyingSurvey" mat-menu-item class=""
                                (click)="askXatBot(node);$event.stopPropagation();"
                                [attr.data-cy]="'qnr-ask-xatbot-' + node.item?.title">
                            <span>Ask XatBot</span>
                        </button>
                    </mat-menu>

                </div>

                <div class="right-section">
                    <div class="tags left">
                    </div>
                    <div class="tags right">
                        <div *ngIf="node.item.visibilityLogicGate.displayText && node.item.visibilityLogicGate.displayText.length>0"
                             class="tag pointer" (click)="addCondition(node,'Add Condition');$event.stopPropagation();"
                             [attr.data-cy]="'qnr-visibility-condition-' + node.item?.title"
                             matTooltip="{{node?.item?.visibilityLogicGate?.toolTip}}" matTooltipPosition="'left'">
                            {{node.item.visibilityLogicGate.displayText}}
                        </div>
                        <!--<div *ngIf="!node.item?.isCustom"  class="tag">
                          <i class="fas fa-database" matTooltip="Field: Data submitted for this question will be stored in the relevant field inside ITP."></i>
                        </div>-->
                        <div
                                *ngIf="(node && (flowChartDataService.dataTypeConfig && flowChartDataService.dataTypeConfig.dataTypes[node.item.dataType] || node.item.dataTypeText))"
                                class="tag">
                            {{(flowChartDataService.dataTypeConfig && flowChartDataService.dataTypeConfig.dataTypes[node.item.dataType])
                            ? flowChartDataService.dataTypeConfig.dataTypes[node.item.dataType].displayText : node.item.dataTypeText}}
                        </div>

                        <!-- <div *ngIf="node.item?.fieldValues?.FormulaExpression" class="tag">
                          <span
                            matTooltip="There is a formula active for this field which will calculate the total value based on the inputs given for the subfields included in the formula. Click this button to review and edit the formula.">Formula ({{node.item?.fieldValues.FormulaFieldsCount}}
                            )</span>
                        </div> -->
                    </div>
                </div>
            </div>
        </mat-tree-node>

        <mat-tree-node class="custom-tree-node" [id]="node.id"
                       [attr.data-cy]="'qnr-field-node-' + node.item?.title"
                       [ngClass]="{'control-show': node.item.id === selectedNodeId,'frozen-node':node.item.frozen==true,'excluded-item':node.item.isHidden==true || node.item.isParentHidden==true}"
                       attr.question-id="{{node.item.questionId}}"
                       (click)="onSelectedNode(node); $event.stopPropagation();"
                       *matTreeNodeDef="let node;when: hasChild" cdkDrag [cdkDragData]="node"
                       [cdkDragDisabled]="isDragDisabled"
                       (mouseenter)="dragHover(node)" (mouseleave)="dragHoverEnd()" (cdkDragStarted)="dragStart()"
                       (cdkDragReleased)="dragEnd()">
            <div *ngIf="flowChartDataService.excludeHiddenQuestions && menuConfig.addField.isVisible && !isFieldSchema"
                 class="flow-chart-control">
                <a title="Add Field" (click)="onAdd(node,isManageFields)"
                   *ngIf="node.item.visibilityLogicGate.visibilityType !== 'AlwaysHidden'"
                   [attr.data-cy]="'qnr-add-field-control-' + node.item?.title">
                    <i class="fal fa-plus-circle flex flex-row justify-center items-center"></i>
                </a>
                <!--<a *ngIf="!isManageFields" title="Add Question" (click)="onAdd(node,false)">
                  <i class="fal fa-plus-circle" fxLayout="row" fxLayoutAlign="center center"></i>
                </a>-->
                <a [ngClass]="{'disabled': !flowChartControlPanel.isMoveUp}" title="Move to Up" (click)="moveUp(node)"
                   [attr.data-cy]="'qnr-move-up-' + node.item?.title">
                    <i class="fal fa-arrow-to-top flex flex-row justify-center items-center"></i>
                </a>
                <a *ngIf="!isManageFields" [ngClass]="{'disabled': !flowChartControlPanel.isMoveLeft}"
                   title="Move to Left"
                   (click)="moveLeft(node)"
                   [attr.data-cy]="'qnr-move-left-' + node.item?.title">
                    <i class="fal fa-arrow-to-left flex flex-row justify-center items-center"></i>
                </a>
                <a *ngIf="!isManageFields" [ngClass]="{'disabled': !flowChartControlPanel.isMoveRight}"
                   title="Move to Right"
                   (click)="moveRight(node)"
                   [attr.data-cy]="'qnr-move-right-' + node.item?.title">
                    <i class="fal fa-arrow-to-right flex flex-row justify-center items-center"></i>
                </a>
                <a [ngClass]="{'disabled': !flowChartControlPanel.isMoveDown}" title="Move to Bottom"
                   (click)="moveDown(node)"
                   [attr.data-cy]="'qnr-move-down-' + node.item?.title">
                    <i class="fal fa-arrow-to-bottom flex flex-row justify-center items-center"></i>
                </a>
            </div>
            <div class="node-wrapper w-p-100 flex flex-row justify-start items-center"
                 [style.padding-left.px]="getMatTreeNodePadding(node)" [ngClass]="{'state-highlight': node.item.id === selectedNodeId ,
  'state-hidden':node.item.visibilityLogicGate.visibilityType==='AlwaysHidden'
        }">
                <div class="left-section flex flex-row justify-start items-center full-grow-no-shrink-no-basis">
                    <div class="button-container">
                        <button *ngIf="node.item?.children.length>0" mat-icon-button matTreeNodeToggle
                                [attr.data-cy]="'qnr-field-toggle-' + node.item?.title"
                                [attr.aria-label]="'toggle ' + node.item?.title">
                            <mat-icon class="mat-icon-rtl-mirror">
                                {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                            </mat-icon>
                        </button>
                    </div>
                    <div *ngIf="hasCheckbox" style="display: flex;">
                        <mat-checkbox
                                [attr.data-cy]="'qnr-field-checkbox-' + node.item?.title"
                                [disabled]="node.item?.fieldValues['DisableSelection'] === true"
                                [checked]="node.item?.isChecked"
                                (change)="onSelectionChange($event, node)">
                        </mat-checkbox>
                    </div>

                    <div class="content-container flex flex-row justify-start items-center full-grow-no-shrink-no-basis">
                        <div *ngIf="node.item?.conditionDisplayText && node.item?.conditionDisplayText.length"
                             class="tagg flex flex-row justify-start items-center"
                             title="{{node.item?.conditionDisplayText}}">
                            <div class="custom-icon flex flex-col">
                                <span></span>
                                <span></span>
                            </div>
                            {{node.item?.conditionDisplayText}}
                        </div>
                        <div class="content flex flex-row justify-start items-start full-grow-no-shrink-no-basis"
                             title="{{node.item?.instruction ? node.item?.instruction : ''}}">
                            <div>{{node.item?.questionId}}.</div>
                            <div class="m-l-5 content-title">{{node.item?.title}} {{node.item?.isMandatory ? ' *' : ''}}</div>
                            <div class="description flex-1-0-auto hide"
                                 title="{{node.item?.instruction ? node.item?.instruction : ''}}">
                                {{node.item?.instruction ? node.item?.instruction : ''}}</div>
                        </div>
                    </div>
                </div>
                <div *ngIf="isManageFields || isFieldSchema" class="single-node-menu-container m-r-14">
                    <div class="tags-container">
                        <div *ngIf="node.item?.identityField" class="tag">
                            <span>Primary Key</span>
                        </div>
                        <div *ngIf="node.item?.formulaField" class="tag">
                            <span>Formula Field</span>
                        </div>
                      <div *ngIf="node.item?.questionType ==='Question' && !node.item?.parentId" class="tag">
                        <span matTooltip="Question: Data submitted for this item is for reference only.">Field</span>
                      </div>
                      <div *ngIf="node.item?.questionType ==='Question' && node.item?.parentId" class="tag">
                        <span matTooltip="Question: Data submitted for this item is for reference only.">Subfield</span>
                      </div>
                        <div *ngIf="node.item?.questionType==='Field'" class="tag">
            <span
                    matTooltip="Field: Data submitted for this item can be stored in the relevant field inside ITP.">Field</span>
                        </div>
                        <div *ngIf="node.item?.fieldValues?.FormulaExpression" class="tag">
            <span
                    matTooltip="This is a formula field, and the value will be calculated from its subfields. Click this button to review and edit the formula.">Formula
              ({{node.item?.fieldValues.FormulaFieldsCount}})</span>
                        </div>
                        <div *ngIf="node?.level > 0 && this.flowChartDataService?.fieldValues?.IsAutoGeneratedFile"
                             class="tag">
                            <span>Subfield</span>
                        </div>
                    </div>
                    <button *ngIf="menuConfig.menuVisibility.isVisible" mat-icon-button [matMenuTriggerFor]="actionMenu"
                            class="no-animation-btn icon-dropdown-button"
                            [attr.data-cy]="'qnr-field-actions-' + node.item?.title"
                            (click)="triggerForMatMenu(node)">
                        <mat-icon class="s-20">more_horiz</mat-icon>
                    </button>
                    <mat-menu #actionMenu="matMenu" class="action-button-dropdown-container" [overlapTrigger]="false">
                        <!--<button *ngIf="!node.item.isHidden" mat-menu-item class=""  (click)="openDetailsPopUp(node)">
                          <span>View Details</span>
                        </button>-->
                        <button mat-menu-item class=""
                                *ngIf="menuConfig.addField.isVisible &&  node.item.visibilityLogicGate.visibilityType !== 'AlwaysHidden'"
                                (click)="onAdd(node,true)"
                                [attr.data-cy]="'qnr-add-subfield-' + node.item?.title">
                            <span>{{menuConfig.addField.displayText}}</span>
                        </button>
                        <button *ngIf="!node.item.isHidden && !node.item.frozen && !node.item.identityField && (!isFieldSchema || menuConfig.details.isVisible)"
                                mat-menu-item class=""
                                (click)="editQuestion(node)"
                                [attr.data-cy]="'qnr-edit-field-' + node.item?.title">
                            <span>{{menuConfig.editField.displayText}}</span>
                        </button>
                        <button
                                *ngIf="!node.item.isHidden && flowChartDataService.excludeHiddenQuestions  && (!isManageFields || node.item.isCustom) && (!isFieldSchema || menuConfig.details.isVisible)"
                                mat-menu-item class="" (click)="onEditDetailsAndInstructions(node)"
                                [attr.data-cy]="'qnr-details-' + node.item?.title">
                            <span>{{menuConfig.details.displayText}}</span> <!--{{node.item?.questionType}}-->
                        </button>
                        <button *ngIf="!node.item.isHidden && !node.item.frozen && !node.item.identityField && node.item.isCustom"
                                mat-menu-item class="" (click)="delete(node)"
                                [attr.data-cy]="'qnr-delete-field-' + node.item?.title">
                            <span>{{menuConfig.deleteField.displayText}}</span>
                        </button>
                      <button
                        *ngIf="!node.item.isHidden && !node.item.frozen && !node.item.identityField && isFieldSchema && menuConfig.manageFormula.isVisible && IsDataTypeNumberOrPercentage(node)"
                        mat-menu-item class="" (click)="manageFormula(node)"
                        [attr.data-cy]="'qnr-manage-formula-' + node.item?.title">
                        <span>{{menuConfig.manageFormula.displayText}}</span>
                      </button>
                        <button *ngIf="!node.item.isHidden && (!isFieldSchema || menuConfig.details.isVisible)"
                                mat-menu-item class=""
                                (click)="addSnippet(node,true);$event.stopPropagation();"
                                [attr.data-cy]="'qnr-add-snippet-' + node.item?.title">
                            <span>{{menuConfig.moveField.displayText}}</span>
                        </button>
                    </mat-menu>
                </div>
                <div *ngIf="!(isManageFields || isFieldSchema)" class="single-node-menu-container m-r-14">
                    <div class="tags-container">
                        <div *ngIf="node.item?.identityField" class="tag">
                            <span>Primary Key</span>
                        </div>
                        <div *ngIf="node.item?.formulaField" class="tag">
                            <span>Formula Field</span>
                        </div>
                      <div *ngIf="node.item?.questionType ==='Question' && !node.item?.parentId" class="tag">
                        <span matTooltip="Question: Data submitted for this item is for reference only.">Field</span>
                      </div>
                      <div *ngIf="node.item?.questionType ==='Question' && node.item?.parentId" class="tag">
                        <span matTooltip="Question: Data submitted for this item is for reference only.">Subfield</span>
                      </div>
                        <div *ngIf="node.item?.questionType==='Field'" class="tag">
            <span
                    matTooltip="Field: Data submitted for this item can be stored in the relevant field inside ITP.">Field</span>
                        </div>
                        <div *ngIf="node.item?.fieldValues?.FormulaExpression" class="tag">
            <span
                    matTooltip="This is a formula field, and the value will be calculated from its subfields. Click this button to review and edit the formula.">Formula
              ({{node.item?.fieldValues.FormulaFieldsCount}})</span>
                        </div>
                        <!--<div *ngIf="node?.level > 0 && this.flowChartDataService?.fieldValues?.IsAutoGeneratedFile"
                             class="tag">
                            <span>Subfield</span>
                        </div>-->
                    </div>
                    <button mat-icon-button [matMenuTriggerFor]="actionMenu"
                            class="no-animation-btn icon-dropdown-button"
                            [attr.data-cy]="'qnr-field-actions-' + node.item?.title"
                            (click)="triggerForMatMenu(node)">
                        <mat-icon class="s-20">more_horiz</mat-icon>
                    </button>
                    <mat-menu #actionMenu="matMenu" class="action-button-dropdown-container" [overlapTrigger]="false">
                        <!--<button *ngIf="!node.item.isHidden" mat-menu-item class=""  (click)="openDetailsPopUp(node)">
                          <span>View Details</span>
                        </button>-->
                        <!--<button *ngIf="!flowchart.isCustom && !node.item.isHidden" mat-menu-item class=""  (click)="showFlowchartWarning()"  matTooltip="">
                          <span>Add Field</span>
                        </button>-->
                        <button
                                *ngIf="flowChartDataService.excludeHiddenQuestions && node.item.visibilityLogicGate.visibilityType !== 'AlwaysHidden' &&  !node.item.isHidden && !isManageFields && menuConfig.addField.isVisible"
                                mat-menu-item class="" (click)="onAdd(node,false)"
                                [attr.data-cy]="'qnr-add-subfield-' + node.item?.title"
                                [matTooltip]="menuConfig.addField.tooltip"
                                matTooltipPosition="left">
                            <span>{{menuConfig.addField.displayText}}</span>
                        </button>
                        <button *ngIf="!node.item.isHidden && menuConfig.editField.isVisible" mat-menu-item class=""
                                (click)="editQuestion(node)"
                                [attr.data-cy]="'qnr-edit-field-' + node.item?.title">
                            <span>{{menuConfig.editField.displayText}}</span> <!--{{node.item?.questionType}}-->
                        </button>
                        <button
                                *ngIf="!node.item.isHidden && flowChartDataService.excludeHiddenQuestions && (isManageFields===false || node.item.isCustom === true) && menuConfig.details.isVisible"
                                mat-menu-item class="" (click)="onEditDetailsAndInstructions(node)"
                                [attr.data-cy]="'qnr-details-' + node.item?.title">
                            <span>{{menuConfig.details.displayText}}</span> <!--{{node.item?.questionType}}-->
                        </button>
                        <button
                                *ngIf="flowChartDataService.excludeHiddenQuestions && !node.item.isHidden && node.item.questionType!=='Field'&& (node.item.isCustom || menuConfig.deleteField.isVisible)"
                                mat-menu-item class="" (click)="delete(node)"
                                [attr.data-cy]="'qnr-delete-field-' + node.item?.title">
                            <span>{{menuConfig.deleteField.displayText}}</span>
                        </button>
                        <button
                                *ngIf="node.item.questionType==='Field' && !node.item.frozen && !node.item.identityField && menuConfig.includeExcludeField.isVisible"
                                mat-menu-item class="" (click)="excludeQuestion(node)"
                                [attr.data-cy]="'qnr-include-exclude-field-' + node.item?.title">
                            <span>{{node.item.isHidden ? 'Include Field' : 'Exclude Field'}}</span>
                        </button>
                        <button *ngIf="!node.item.isHidden && menuConfig.conditions.isVisible" mat-menu-item class=""
                                (click)="addCondition(node,'Conditions');$event.stopPropagation();"
                                [attr.data-cy]="'qnr-conditions-' + node.item?.title">
                            <span>{{menuConfig.conditions.displayText}}</span>
                        </button>
                        <button
                                *ngIf="flowChartDataService.excludeHiddenQuestions && !node.item.isHidden && menuConfig.moveField.isVisible"
                                mat-menu-item class=""
                                (click)="moveQuestionBetweenSection(node);$event.stopPropagation();"
                                [attr.data-cy]="'qnr-move-field-' + node.item?.title">
                            <span>{{node.item.questionType === 'Field' ? menuConfig.moveField.displayText : 'Move Question'}}</span>
                        </button>
                        <button *ngIf="!node.item.isHidden && menuConfig.addSnippet.isVisible" mat-menu-item class=""
                                (click)="addSnippet(node,true);$event.stopPropagation();"
                                [attr.data-cy]="'qnr-add-snippet-' + node.item?.title">
                            <span>{{menuConfig.addSnippet.displayText}}</span>
                        </button>
                        <button *ngIf="!node.item.isHidden && menuConfig.addMapQuestion.isVisible" mat-menu-item
                                class=""
                                (click)="addMapQuestion(node);$event.stopPropagation();"
                                [attr.data-cy]="'qnr-add-map-question-' + node.item?.title">
                            <span>{{menuConfig.addMapQuestion.displayText}}</span>
                        </button>
                        <button
                                *ngIf="!node.item.isHidden && menuConfig.manageSubFields.isVisible && (node.item.dataType === 'Number')"
                                mat-menu-item class="" (click)="manageSubFields(node)"
                                [attr.data-cy]="'qnr-manage-subfields-' + node.item?.title">
                            <span>{{menuConfig.manageSubFields.displayText}}</span> <!--{{node.item?.questionType}}-->
                        </button>
                        <button
                                *ngIf="!node.item.isHidden && menuConfig.manageFormula.isVisible  && IsDataTypeNumberOrPercentage(node)"
                                mat-menu-item class="" (click)="manageFormula(node)"
                                [attr.data-cy]="'qnr-manage-formula-' + node.item?.title">
                            <span>{{menuConfig.manageFormula.displayText}}</span> <!--{{node.item?.questionType}}-->
                        </button>
                      <button
                        *ngIf="!node.item.isHidden && menuConfig.viewFormula.isVisible  && IsDataTypeNumberOrPercentage(node)"
                        mat-menu-item class="" (click)="viewFormula(node)"
                        [attr.data-cy]="'qnr-view-formula-' + node.item?.title">
                        <span>{{menuConfig.viewFormula.displayText}}</span> <!--{{node.item?.questionType}}-->
                      </button>
                    </mat-menu>
                </div>
                <div class="right-section">
                    <div class="tags left">
                        <!--          <div class="tag pointer"  (click)="addCondition(node,'Add Condition');$event.stopPropagation();" matTooltip="Click to edit the visibility conditions for this item.">-->
                        <!--            {{node.item.visibilityLogicGate.visibilityType}}-->
                        <!--          </div>-->
                        <!--<div *ngIf="!node.item?.isCustom"  class="tag">
                          <i class="fas fa-database" matTooltip="Field: Data submitted for this question will be stored in the relevant field inside ITP."></i>
                        </div>-->
                        <!--          <div class="tag">-->
                        <!--            <i class="far fa-low-vision"  matTooltip="Question: Data submitted for this item is for reference only."></i>-->
                        <!--          </div>-->
                    </div>
                    <div class="tags right">
                        <div *ngIf="node.item.visibilityLogicGate.displayText && node.item.visibilityLogicGate.displayText.length>0"
                             class="tag pointer" (click)="addCondition(node,'Add Condition');$event.stopPropagation();"
                             [attr.data-cy]="'qnr-visibility-condition-' + node.item?.title"
                             matTooltip="{{node?.item?.visibilityLogicGate?.toolTip}}" matTooltipPosition="left">
                            {{node.item.visibilityLogicGate.displayText}}
                        </div>
                        <!--<div *ngIf="!node.item?.isCustom"  class="tag">
                          <i class="fas fa-database" matTooltip="Field: Data submitted for this question will be stored in the relevant field inside ITP."></i>
                        </div>-->
                        <div
                                *ngIf="(node && (flowChartDataService.dataTypeConfig && flowChartDataService.dataTypeConfig.dataTypes[node.item.dataType] || node.item.dataTypeText))"
                                class="tag">
                            {{(flowChartDataService.dataTypeConfig && flowChartDataService.dataTypeConfig.dataTypes[node.item.dataType])
                            ? flowChartDataService.dataTypeConfig.dataTypes[node.item.dataType].displayText : node.item.dataTypeText}}
                        </div>
                        <!-- <div *ngIf="node.item?.fieldValues?.FormulaExpression" class="tag">
                          <span
                            matTooltip="There is a formula active for this field which will calculate the total value based on the inputs given for the subfields included in the formula. Click this button to review and edit the formula.">Formula ({{node.item?.fieldValues.FormulaFieldsCount}}
                            )</span>
                        </div> -->
                    </div>
                </div>

            </div>

        </mat-tree-node>
    </mat-tree>
</div>
